import { memoize } from 'lodash';

type Target = HTMLElement | Document | Window;

interface PathOrTarget {
  parentNode: PathOrTarget;
}

function getSelectors(path: Target[]) {
  return path
    .reverse()
    .filter((element): element is HTMLElement => {
      return element !== document && element !== window;
    })
    .map((element) => {
      let selector = '';
      // 如果点击的元素有ID的话
      if (element?.id) {
        return `${element.tagName.toLowerCase()}#${element.id}`;
        // 如果点击的元素没有ID有Class的话
      } else if (element?.className && typeof element.className === 'string') {
        return `${element?.tagName.toLowerCase()}.${element.className}`;
        // 如果元素上面两个都没有 那么就将他的元素名称小写返回
      } else {
        selector = element?.tagName;
      }
      return selector;
    })
    .join(' ');
}

export function getSelector(pathOrTarget: PathOrTarget) {
  if (Array.isArray(pathOrTarget)) {
    return getSelectors(pathOrTarget);
  } else {
    while (pathOrTarget) {
      // eslint-disable-next-line
      pathOrTarget = pathOrTarget.parentNode;
    }
    return getSelectors([pathOrTarget]);
  }
}

type LastEvent = Event & { path: PathOrTarget };

let lastEvent: LastEvent;
['click', 'touchstart', 'mousedown', 'keydown', 'mouseover'].forEach((eventType) => {
  document.addEventListener(
    eventType,
    (event) => {
      lastEvent = event as LastEvent;
    },
    {
      capture: true, // 在捕获阶段执行
      passive: true, // 默认不阻止事件
    }
  );
});

export function getLastEvent() {
  return lastEvent;
}

const getMenuPathOrigin = (route, menus, result, level = 1) => {
  if (Array.isArray(menus)) {
    for (let i = 0; i < menus.length; i++) {
      const item = menus[i];
      if (item?.path === route) {
        result.push(item);
        break;
      }
      result.push(item);
      if (Array.isArray(item.children)) {
        getMenuPathOrigin(route, item.children, result, level + 1);
      }
      if (result.length === level) {
        result.pop();
      } else {
        break;
      }
    }
  }
};
const getMenuPath = memoize((route, menus, result, level = 1) => {
  if (Array.isArray(menus)) {
    for (let i = 0; i < menus.length; i++) {
      const item = menus[i];
      if (item?.path === route) {
        result.push(item);
        break;
      }
      result.push(item);
      if (Array.isArray(item.children)) {
        getMenuPathOrigin(route, item.children, result, level + 1);
      }
      if (result.length === level) {
        result.pop();
      } else {
        break;
      }
    }
  }
  return result;
});

/**
 * 获取当前菜单路径指定字段名集合
 * @param field 指定字段名
 */
export function getMenuPathAndExtract(field = 'title') {
  const globalState = window.dvaApp._store.getState().global;
  const menus = globalState?.menu;
  const activeKey = globalState?.activeTabKey;
  const curMenuPath = getMenuPath(activeKey, menus, []);
  return curMenuPath.map((item) => item?.[field]);
}

/**
 * 获取当前菜单路径指定字段名集合
 * @param field 指定字段名
 * @param key 指定key
 */
export function getMenuPathAndExtractByKey(field = 'title', key: string) {
  const globalState = window.dvaApp._store.getState().global;
  const menus = globalState?.menu;
  const curMenuPath = getMenuPath(key, menus, []);
  return curMenuPath.map((item) => item?.[field]);
}

/**
 * 用于延迟上报
 */
export class ReportDefered {
  deferedList;

  constructor() {
    this.deferedList = [];
  }

  addDefered(name: string) {
    let resolve;
    const promise = new Promise((r) => {
      resolve = r;
    });
    this.deferedList.push({
      name,
      promise,
      resolve,
      ready: false,
    });
  }

  setReady(name) {
    const defered = this.deferedList.find((d) => d.name === name);
    defered.ready = true;
    defered.resolve();
  }

  ready() {
    return Promise.all(this.deferedList.map((d) => d.promise));
  }
}

export const performanceReportDefered = new ReportDefered();
performanceReportDefered.addDefered('menu');
// performanceReportDefered.addDefered('ip');
